export function findPipelineWorkspace (workspaceList = [], workspaceId) {
  if (workspaceId === undefined || workspaceId === null || !workspaceList) return null;

  return workspaceList.find((workspace) => (
    workspace._id === workspaceId ||
    workspace.id === workspaceId ||
    workspace.name === workspaceId
  )) || null;
}

export function pipelineHasWorkspace (pipeline, workspaceList) {
  return !!findPipelineWorkspace(workspaceList, pipeline && pipeline.workspace_id);
}

export function normalizePipelineEnabledState (pipeline, workspaceList) {
  if (!pipelineHasWorkspace(pipeline, workspaceList)) {
    return { ...pipeline, enabled: false };
  }

  return pipeline;
}

export function normalizePipelinesEnabledState (pipelines = [], workspaceList = []) {
  return pipelines.map((pipeline) => normalizePipelineEnabledState(pipeline, workspaceList));
}

export function getEnabledPipelinesWithoutWorkspace (pipelines = [], workspaceList = []) {
  return pipelines.filter((pipeline) => pipeline.enabled && !pipelineHasWorkspace(pipeline, workspaceList));
}
